import React from 'react';

interface Props {
  checked?: boolean;
  disabled?: boolean;
  text?: string;
  classes?: string;
  onChange(): void;
}

export default ({
  checked = false,
  text,
  disabled = false,
  classes = '',
  onChange,
}: Props) => {
  const handleChange = () => {
    if (!disabled) {
      onChange();
    }
  };

  var classNames = 'aa-checkbox';
  if (disabled) {
    classNames = `${classNames} ${classNames}--disabled`;
  }

  if (classes) {
    classNames = `${classNames} ${classes}`;
  }

  return (
    <label className={classNames}>
      {text}
      <input
        type='checkbox'
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <span className='aa-checkbox__checkmark'></span>
    </label>
  );
};
